export default {
    downtimeUrl: "https://it.kodland.tech",
    ageRules: {
      min: 5,
      max: 17,
    },
    startPage: {
      image: "/welcome/quiz_project_girl.jpeg",
      title:
        "Iscrivetevi ora a una prima lezione personalizzata di programmazione e a un corso di programmazione ad accesso illimitato!",
      subtitle:
        "Durante il corso online, i ragazzi apprenderanno le basi del coding e creeranno i loro primi progetti",
      button: "Iniziare ora",
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Grazie per aver scelto la nostra piattaforma educativa! Sfortunatamente, tablet e smartphone non sono adatti per seguire le nostre classi. Speriamo ci sarà l'occasione di vederci in classe prossimamente!",
    },
    quizRotateBySteps: {
      1: {
        question: "Come tuo figlio/a trascorre di solito il suo tempo libero?",
        answers: [
            "📱 Giocando ai videogiochi sullo smartphone", 
            "💪 Facendo sport",
            "👀 Guardando i cartoni animati",
            "🎨 Svolgendo attività creative: disegno, musica, recitazione",
            "🤝 Con gli amici",
        ],
      },
      2: {
        question: "Qual è la materia preferita di tuo figlio/a a scuola?",
        answers: [
            "🖥 Informatica", 
            "🔢 Matematica",
            "🎨 Arte, pittura, design",
            "📚 Letteratura",
            "🗣 Lingue straniere",
            "❓ Non ne sono sicuro/a",
        ],
      },
      3: {
        title: "Qual è l'orario per voi più comodo per partecipare a una lezione introduttiva ai nostri corsi?",
        type: "timeslot",
        subtitle:
          "Mancano solo pochi passaggi per prenotare una prima lezione privata! Vi aspettiamo🥳",
        button: "Avanti",
      },
      4: {
        question: "Tuo figlio/a sa utilizzare il computer?",
        answers: [
          "🤝 Sì, conosce bene anche Microsoft Word/PowerPoint",
          "🎮 Sì, gli piace giocare ai videogiochi (Roblox, Minecraft)",
          "🖥 Sì, conosce anche alcune basi di coding",
          "🛑 No",
        ],
      },
      5: {
        question: "Hai un computer fisso/portatile con il quale poter studiare?",
        answers: [
          "✅ Si",
          {
            answer: "❌ No",
            stopAnswer: true
          },
        ],
      },
      6: {
        title: "Quanti anni ha tuo figlio/a?",
        type: "age",
        subtitle: "Quanti anni ha tuo figlio/a?",
        button: "Avanti",
      },
      7: {
        title: "Come si chiama tuo figlio/a?",
        type: "child_name",
        subtitle:
          "I dati che ci fornisci sono protetti e verranno eliminati in caso ce lo richiedessi 🚨",
        button: "Avanti",
      },
      8: {
        title: "Inserisci un indirizzo email",
        type: "mail",
        subtitle: "Non preoccuparti, nessuno spam😅",
        button: "Avanti",
      },
      9: {
        title: "Inserisci un numero di telefono",
        type: "phone",
        subtitle: "Lo utilizzeremo per comunicarti informazioni importanti 📞!",
        button: "Avanti",
      },
      10: {
        title: "Inserisci il tuo nome",
        type: "parent_name",
        subtitle: "Il nostro nome è Kodland, e il tuo? 👋",
        button: "Terminare la registrazione",
      },
    },
  };
  